export default {
  title: 'ディーラー管理',
  dealerList: 'ディーラー一覧',
};
